
import axios from 'axios';
import { supabase } from './supabaseClient';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false 
});

// Add request interceptor
api.interceptors.request.use(
  async (config) => {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error) {
      console.warn('⚠️ Failed to get Supabase session:', error.message);
    }

    const token = session?.access_token;
    const refreshToken = session?.refresh_token;
    const fingerprint = localStorage.getItem('fingerprint');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (refreshToken) {
      config.headers['X-Refresh-Token'] = refreshToken;
    }
    if (fingerprint) {
      config.headers['X-Fingerprint'] = fingerprint;
    }


    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
